export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8"
      data-testid={testid}
    >
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#2B2D42] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-slate-muted mt-2 text-base">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex gap-3 flex-wrap">{actions}</div>}
    </div>
  );
}
